import { IDepartmentListSelectorDialogCondition, instanceOfIDepartmentListSelectorDialogCondition } from "./IDepartmentListSelectorDialogCondition";

export interface IMultiDepartmentListSelectorDialogCondition extends IDepartmentListSelectorDialogCondition {
  isMultiSelectable: boolean;
}

export function instanceOfIMultiDepartmentListSelectorDialogCondition(instance: any): instance is IMultiDepartmentListSelectorDialogCondition {
  return instance
  && (instance.isMultiSelectable !== undefined)
  && instanceOfIDepartmentListSelectorDialogCondition(instance);
}
